export enum answerEnvironmentActionTypes {
  SET_ANSWER_USER = 'SET_ANSWER_USER',
  SET_ANSWER_CONTEXT = 'SET_ANSWER_CONTEXT',
  SET_ANSWER_QUESTIONNAIRE_CONTEXT = 'SET_ANSWER_QUESTIONNAIRE_CONTEXT',
  SET_ANSWER_DOWNLOAD = 'SET_ANSWER_DOWNLOAD',
  SET_ANSWER_USER_ABBR = 'SET_ANSWER_USER_ABBR',
  SET_ANSWER_ATTACHMENTS = 'SET_ANSWER_ATTACHMENTS',
  SET_ANSWER_LANGUAGE = 'SET_ANSWER_LANGUAGE',
}
